module.exports = __webpack_public_path__ + "static/media/landscape.111ef3e2.jpg";